import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const storageType = localStorage.getItem("rememberMe") === "true" ? localStorage : sessionStorage;

  const [isLoggedIn, setIsLoggedIn] = useState(() => storageType.getItem("isLoggedIn") === "true");
  const [user, setUser] = useState(() => storageType.getItem("user") || null);
  const [token, setToken] = useState(() => storageType.getItem("token") || null);
  const [redirectAfterLogin, setRedirectAfterLogin] = useState(null);

  useEffect(() => {
    const storage = localStorage.getItem("rememberMe") === "true" ? localStorage : sessionStorage;
    storage.setItem("isLoggedIn", isLoggedIn);

    if (user && token) {
      storage.setItem("user", user);
      storage.setItem("token", token);
    } else {
      storage.removeItem("user");
      storage.removeItem("isLoggedIn");
      storage.removeItem("token");
    }
  }, [isLoggedIn, user, token]);

  const login = (userId, authToken, rememberMe) => {
    localStorage.setItem("rememberMe", rememberMe); // Store the preference

    setIsLoggedIn(true);
    setUser(userId);
    setToken(authToken);
  };

  const logout = () => {
    setIsLoggedIn(false);
    setUser(null);
    setToken(null);
    localStorage.removeItem("rememberMe");
  };


  return (
    <AuthContext.Provider
      value={{
        login,
        logout,
        isLoggedIn,
        user,
        token,
        redirectAfterLogin,
        setRedirectAfterLogin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
